// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3VVS3","containerItemsCenter":"Skeleton_containerItemsCenter__N18op"};